/**
 * Propose the next TemplateVersion version_code for Admin publish UX.
 * Server UNIQUE(checklist_template_id, version_code) remains authoritative.
 */
export function proposeNextVersionCode(existingCodes: readonly string[]): string {
  const existing = new Set(
    existingCodes.map((code) => code.trim()).filter((code) => code.length > 0),
  );
  const numericPairs: Array<{ major: number; minor: number }> = [];
  for (const code of existing) {
    const match = /^(\d+)\.(\d+)$/.exec(code);
    if (match === null) {
      continue;
    }
    numericPairs.push({
      major: Number(match[1]),
      minor: Number(match[2]),
    });
  }

  let candidate: string;
  if (numericPairs.length === 0) {
    candidate = '1.0';
  } else {
    let best = numericPairs[0]!;
    for (const pair of numericPairs.slice(1)) {
      if (pair.major > best.major || (pair.major === best.major && pair.minor > best.minor)) {
        best = pair;
      }
    }
    candidate = `${best.major}.${best.minor + 1}`;
  }

  while (existing.has(candidate)) {
    const match = /^(\d+)\.(\d+)$/.exec(candidate);
    if (match === null) {
      candidate = `${candidate}-next`;
      continue;
    }
    candidate = `${Number(match[1])}.${Number(match[2]) + 1}`;
  }
  return candidate;
}
